function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { uniqueId } from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import { useEffectOnce } from 'react-use';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var MountContext = /*#__PURE__*/React.createContext({});
var topRender = new Map();
var Render = function Render() {
  var state = useState(new Map());
  var ref = useRef({
    render: uniqueId('render-instance-')
  });
  var _state = _slicedToArray(state, 1),
    map = _state[0];
  useEffectOnce(function () {
    var key = ref.current;
    topRender.set(key, state);
    return function () {
      topRender.delete(key);
    };
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: Array.from(map.values())
  });
};
export var mount = function mount(element, option) {
  if (topRender.size === 0) {
    throw new Error('no render instance');
  }
  var renderInstances = Array.from(topRender.values());
  var _renderInstances = _slicedToArray(renderInstances[renderInstances.length - 1], 2),
    dispatch = _renderInstances[1];
  var uuid = uniqueId('render-element-');
  var unmount = function unmount() {
    var _option$onUnmount;
    dispatch(function (map) {
      map.delete(uuid);
      return new Map(map);
    });
    option === null || option === void 0 || (_option$onUnmount = option.onUnmount) === null || _option$onUnmount === void 0 || _option$onUnmount.call(option);
  };
  var update = function update(props) {
    var _option$onUpdate;
    dispatch(function (map) {
      var oldElement = map.get(uuid);
      if (oldElement) {
        var handler = {
          unmount: unmount,
          update: update
        };
        map.set(uuid, /*#__PURE__*/_jsx(MountContext.Provider, {
          value: handler,
          children: /*#__PURE__*/React.cloneElement(oldElement, _objectSpread(_objectSpread({}, props), handler))
        }, uuid));
        return new Map(map);
      }
      return map;
    });
    option === null || option === void 0 || (_option$onUpdate = option.onUpdate) === null || _option$onUpdate === void 0 || _option$onUpdate.call(option, props);
  };
  dispatch(function (map) {
    var handler = {
      unmount: unmount,
      update: update
    };
    map.set(uuid, /*#__PURE__*/_jsx(MountContext.Provider, {
      value: handler,
      children: /*#__PURE__*/React.cloneElement(element, handler)
    }, uuid));
    return new Map(map);
  });
  return {
    unmount: unmount,
    update: update
  };
};

/**
 * 自动关联当前组件生命周期，自动移除挂载组件
 * @param element
 * @returns
 */
export var useMount = function useMount() {
  var instances = useRef([]);
  useEffect(function () {
    return function () {
      instances.current.forEach(function (instance) {
        instance.unmount();
      });
    };
  }, []);
  return function (element, option) {
    var target = mount(element, {
      onUnmount: function onUnmount() {
        var _option$onUnmount2;
        instances.current = instances.current.filter(function (i) {
          return i !== target;
        });
        option === null || option === void 0 || (_option$onUnmount2 = option.onUnmount) === null || _option$onUnmount2 === void 0 || _option$onUnmount2.call(option);
      }
    });
    instances.current.push(target);
    return target;
  };
};
export var useMountMethod = function useMountMethod() {
  return React.useContext(MountContext);
};
export default Render;